import { Directive, HostListener, inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';

import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ComponentFunctions } from '../component-functions';
import { DialogEditConfig } from './dialog-edit-config';
import { SummitFormBase } from './summit-form-base';

@Directive()
export abstract class SummitFormDialogPrime<T> extends SummitFormBase {
  protected dialogRef: DynamicDialogRef;
  protected dialogConfig: DynamicDialogConfig;
  protected configData: DialogEditConfig<T>;
  protected formBuilder: FormBuilder;

  constructor() {
    super();
    this.formBuilder = inject(FormBuilder);
    this.dialogRef = inject(DynamicDialogRef);
    this.dialogConfig = inject(DynamicDialogConfig);
    //console.log('this.dialogConfig', this.dialogConfig);
    this.configData = this.dialogConfig.data;
  }

  onNoClick(): void {
    this.closeIfAllowed();
  }
  close($event): void {
    $event.stopPropagation();
    $event.preventDefault();
    this.closeIfAllowed();
  }

  @HostListener('window:keyup.esc') onKeyUp() {
    this.closeIfAllowed();
  }

  private async closeIfAllowed() {
    if (await ComponentFunctions.IsValidToUnloadAsync(this)) {
      this.elementForm.reset();
      this.dialogRef.close();
    }
  }

  onSave($event?: unknown): void {
    if ($event instanceof MouseEvent) {
      $event.stopPropagation();
      $event.preventDefault();
    }
    if (this.preSaveCheck() === false) {
      return;
    }
    this.dialogRef.close(this.elementForm.value);
  }
}
